import type { UserOverview } from '@/types/messages.ts';

/** How a person is named on the Messages page: their name, else their address, else their id. */
export function personName(
  person: Pick<UserOverview, 'id' | 'first_name' | 'last_name' | 'email'>,
): string {
  return (
    `${person.first_name ?? ''} ${person.last_name ?? ''}`.trim() ||
    person.email ||
    person.id
  );
}
